export default __webpack_public_path__ + "static/media/cloudkit_wrapper.d00afa8b.svg";